const inputBase = {
  width: "100%",
  padding: "8px",
  margin: "8px 0",
  borderRadius: "4px",
  border: "1px solid var(--border)",
  backgroundColor: "var(--surface)",
  color: "var(--text)",
  boxSizing: "border-box",
};

// Segmented pill control for Task State, matching the recurring detail
// screen's "Create as" chips.
const PRIMARY = "#007bff";
const chipBase = {
  padding: "8px 16px",
  borderRadius: "16px",
  cursor: "pointer",
  fontSize: "13px",
};

const styles = {
  input: { ...inputBase },
  textarea: { ...inputBase, height: "280px" },
  select: { ...inputBase },
  chipRow: { display: "flex", gap: "8px", flexWrap: "wrap", margin: "8px 0" },
  chip: {
    ...chipBase,
    border: "1px solid var(--border)",
    background: "transparent",
    color: "var(--text)",
  },
  chipOn: {
    ...chipBase,
    border: `1px solid ${PRIMARY}`,
    background: PRIMARY,
    color: "#fff",
  },
  deleteButton: {
    marginTop: "32px",
    backgroundColor: "#ff4d4d", // danger red, intentional in both themes
    color: "#fff",
    border: "none",
    padding: "12px 16px",
    borderRadius: "8px",
    cursor: "pointer",
    width: "100%", // Full width button
  },
};

export default styles;
